<div class="content">
  <app-autosaved-drafts />
  <app-autosave-options />
</div>
